.displayXl {
  font: var(--display-xl-font);
  letter-spacing: var(--display-xl-letter-spacing);
}

.displayLg {
  font: var(--display-lg-font);
  letter-spacing: var(--display-lg-letter-spacing);
}

.displayMd {
  font: var(--display-md-font);
  letter-spacing: var(--display-md-letter-spacing);
}

.displaySm {
  font: var(--display-sm-font);
  letter-spacing: var(--display-sm-letter-spacing);
}
